import React, { useState, useEffect } from 'react';
import './../assets/css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import BannerDesk from "./../img/2025/bannerBottom/libertadores1.png";
import BannerMob from "./../img/2025/bannerBottom/libertadoresMob.png";

import BannerBottom1 from './../img/2025/bannerBottom/bone.png';
import BannerBottom2 from './../img/2025/bannerBottom/camisa.png';
import BannerBottom3 from './../img/2025/bannerBottom/casual.png';
import BannerBottom4 from './../img/2025/bannerBottom/chuteira.png';

function BannerBottomBlack() {
    const [BannerFull, setBannerFull] = useState(BannerDesk);
    const [BannerFullMob, setBannerFullMob] = useState(BannerMob);
  
    const bannersbottom = {
      dots: true,
      arrows: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      responsive: [
        { breakpoint: 600,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1 } }
      ],
    };
  
    /* const BannerBottom1 = 'https://blackfriday.futfanatics.com.br/img/banner/bannersblack/trio-bottom_1.png';
    const BannerBottom2 = 'https://blackfriday.futfanatics.com.br/img/banner/bannersblack/trio-bottom_2.png';
    const BannerBottom3 = 'https://blackfriday.futfanatics.com.br/img/banner/bannersblack/trio-bottom_3.png'; */
  
    useEffect(() => {
      const dataCondicao = new Date('2025-12-01T00:00:00');
      const dataAtual = new Date();
  
      if (
        dataAtual.getTime() >= dataCondicao.getTime()
      ) {
        setBannerFull('https://blackfriday.futfanatics.com.br/img/banner/bannersblack/banner-middle-prorrogado.png');
        setBannerFullMob('https://blackfriday.futfanatics.com.br/img/banner/bannersblack/banner-middle_mobile-prorrogado.png');
      }
    }, []); 
  
  return (
    <>
      <div className='box-banner-full'>
        <a href="https://www.futfanatics.com.br/clubes-brasileiros?loja=311840&categoria=11&range=&variacao=clube-de-futebol_flamengo&variacao=clube-de-futebol_palmeiras">
          <img className='banner-full d-md-none' src={BannerFull} alt="BannerFull" />
          <img className='banner-full d-md-block d-none' src={BannerFullMob} alt="BannerFullMob" />
        </a>        
      </div>
      <div className='container mt-3'>
        <Slider {...bannersbottom} className='slick-banners_bottom'>
          <div className='item'>
            <a href='https://www.futfanatics.com.br/bone?order=1'>
              <img className='bannersBottom' src={BannerBottom1} alt="BannerBottom1" />
            </a>
          </div>
          <div className='item'>
            <a href='https://www.futfanatics.com.br/clubes-brasileiros?loja=311840&categoria=11&range=&variacao=camisa-oficial_sim&order=4'>
              <img className='bannersBottom' src={BannerBottom2} alt="BannerBottom2" />
            </a>
          </div>
          <div className='item'>
            <a href='https://www.futfanatics.com.br/casual?&order=3'>
              <img className='bannersBottom' src={BannerBottom3} alt="BannerBottom3" />
            </a>
          </div>
          <div className='item'>
            <a href='https://www.futfanatics.com.br/futebol/chuteiras?order=1'>
              <img className='bannersBottom' src={BannerBottom4} alt="BannerBottom4" />
            </a>
          </div>
        </Slider>
      </div>
    </>
  );
}

export default BannerBottomBlack;
